import ModuleWrapper from 'shared-lib/containers/Module';

const Reports  = () => import(/* webpackChunkName: "reports" */ '@/views/reports/Reports');
const CustomReports  = () => import(/* webpackChunkName: "custom-reports" */ '@/views/reports/CustomReports');
const Report = () => import(/* webpackChunkName: "report-view" */ '@/views/reports/Report');
const PostbacksReport = () => import(/* webpackChunkName: "postbacks-report" */ '@/views/reports/PostbacksReport');
const EventsReport = () => import(/* webpackChunkName: "events-report" */ '@/views/reports/EventsReport');
const ClicksReport = () => import(/* webpackChunkName: "clicks-report" */ '@/views/reports/ClicksReport');
const ServerReport = () => import(/* webpackChunkName: "server-report" */ '@/views/reports/ServerReport');
const ConversionDetails = () => import (/* webpackChunkName: "conversion-details" */ '@/views/reports/conversion/ConversionDetails');

const meta = (data = {}) => ({
    permissionsModuleName: 'analytics',
    title: 'Analytics',
    auth: true,
    permission: 'overview',
    ...data,
});

export default [{
    path: 'reports',
    component: ModuleWrapper,
    meta: meta(),
    children: [
        {
            path: '',
            name: 'Reports',
            component: Reports,
            meta: meta(),
        },
        {
            path: ':reportId(\\d+)',
            name: 'UserCustomReport',
            component: Report,
            props: true,
            meta: meta(),
        },
        {
            path: 'custom-reports/new',
            name: 'NewCustomReport',
            component: Report,
            props: {
                reportName: 'Custom Report',
                useLocalStorage: true,
                childModuleName: 'customReport',
            },
            meta: meta(),
        },
        {
            path: 'custom-reports',
            name: 'CustomReports',
            component: CustomReports,
            meta: meta(),
        },
        {
            path: 'traffic-source',
            name: 'TrafficSourceReport',
            component: Report,
            props: {
                reportName: 'Publisher Report',
                reportSettings: {
                    dimensions: ['partner_id'],
                },
                childModuleName: 'publisherReport',
            },
            meta: meta(),
        },
        {
            path: 'advertiser',
            name: 'AdvertiserReport',
            component: Report,
            props: {
                reportName: 'Advertiser Report',
                reportSettings: {
                    dimensions: ['advertiser_id'],
                },
                childModuleName: 'advertiserReport',
            },
            meta: meta(),
        },
        {
            path: 'offer',
            name: 'OfferReport',
            component: Report,
            props: {
                reportName: 'Offer Report',
                reportSettings: {
                    dimensions: ['offer_id'],
                },
                childModuleName: 'offerReport',
            },
            meta: meta(),
        },
        {
            path: 'fraud',
            name: 'FraudReport',
            component: Report,
            props: {
                reportName: 'Fraud Report',
                reportSettings: {
                    dimensions: ['vetting_strategy_id'],
                },
                childModuleName: 'fraudReport',
            },
            meta: meta(),
        },
        {
            path: 'postbacks',
            name: 'PostbacksReport',
            component: PostbacksReport,
            meta: meta({
                permission: 'overview',
            }),
        },
        {
            path: 'events',
            name: 'EventsReport',
            component: EventsReport,
            meta: meta(),
        },
        {
            path: 'clicks',
            name: 'ClicksReport',
            component: ClicksReport,
            props: {
                reportName: 'Clicks Report',
                reportType: 'clicks',
            },
            meta: meta(),
        },
        {
            path: 'blocked-clicks',
            name: 'BlockedClicksReport',
            component: ClicksReport,
            props: {
                reportName: 'Blocked Clicks Report',
                reportType: 'blockedClicks',
            },
            meta: meta(),
        },
        {
            path: 'server',
            name: 'ServerReport',
            component: ServerReport,
            props: {
                reportName: 'Server Report',
                reportType: 'server',
            },
            meta: meta(),
        },
        {
            path: 'conversion/:ydrid',
            name: 'ConversionDetails',
            component: ConversionDetails,
            props: true,
            meta: meta(),
        },
        {
            path: 'manual-adjustment',
            name: 'ManualAdjustment',
            component: Report,
            props: {
                childModuleName: 'manualAdjustment',
                withChart: false,
                reportSettings: {
                    dimensions: ['offer_id', 'partner_id', 'tsp'],
                },
            },
            meta: {
                ...meta(),
                customGuard: (store) => store?.getters?.config?.feature?.manual_adjustment?.enabled && store?.getters?.isCurrentUserAdmin,
            },
        },
    ],
}];
